import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import { selectAllProductSettings } from "../../../redux/slices/productSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import ReceiptDeliveryDetails from "./ReceiptDeliveryDetails";

const ConnectedReceiptDeliveryDetails = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const productSettings = useSelector(selectAllProductSettings);
    const { deliveryInfo = "" } = productSettings;

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { deliveryDetailsLabel = "A Note About Delivery" },
    } = control;

    const isVisible = deliveryInfo && deliveryInfo.length > 0;

    const receiptDeliveryDetailsProps = {
        deliveryDetailsLabel,
        deliveryInfo,
        isVisible,
    };

    return <ReceiptDeliveryDetails {...receiptDeliveryDetailsProps} />;
};

ConnectedReceiptDeliveryDetails.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptDeliveryDetails;
